// extracted by mini-css-extract-plugin
export var actionButton = "_k6-0";
export var fileInput = "_k6-2";
export var paperclip = "_k6-1";